'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { AnimatedButton } from '@/components/ui/animated-button';
import { SilkSheet } from '@/components/ui/silk-sheet';
interface LimitReachedModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Shown when a user has already submitted 5 suggestions for this
 * market and taps the "+ Suggest outcome" CTA. Soft block — no
 * additional action available; just informs the cap.
 */
export function LimitReachedModal(t0) {
  const $ = _c(26);
  const {
    open,
    onOpenChange
  } = t0;
  const t = useTranslations("launchpad.suggestedOutcomes.limit");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex size-14 items-center justify-center rounded-full bg-feedback-warning-surface text-heading-md font-bold text-feedback-warning-content">5/5</div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <h2 className="text-heading-md">{t2}</h2>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("body");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <p className="mt-2 max-w-prose-width text-caption text-foreground-secondary">{t4}</p>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <div>{t3}{t5}</div>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== onOpenChange) {
    t7 = () => onOpenChange(false);
    $[12] = onOpenChange;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t("back");
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t7 || $[17] !== t8) {
    t9 = <AnimatedButton variant="primary" size="sm" onClick={t7}>{t8}</AnimatedButton>;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t6 || $[20] !== t9) {
    t10 = <div className="flex flex-col items-center gap-4 p-6 text-center">{t1}{t6}{t9}</div>;
    $[19] = t6;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== onOpenChange || $[23] !== open || $[24] !== t10) {
    t11 = <SilkSheet open={open} onOpenChange={onOpenChange} variant="detached" size="default">{t10}</SilkSheet>;
    $[22] = onOpenChange;
    $[23] = open;
    $[24] = t10;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
}